module.exports = __webpack_public_path__ + "static/media/a1.d944820.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/suchunyuan/a1.mp3
// module id = cedv
// module chunks = 0